
import merge  from '../fn/stream/merge.js';
import events from '../dom/modules/events.js';
import { px } from '../dom/modules/parse-length.js';

export default function setupView(element, state) {
    return merge(
        [{ target: { value: 'grid-view' } }],
        events({ type: 'change', select: '[name=view]' }, element)
    )
    .reduce((c0, e) => {
        const c1 = e.target.value;

        if (c1 !== c0) {
            element.classList.remove(c0);
            element.classList.add(c1);
        }

        if (c1 === 'grid-view') {
            state.masonry = new Masonry(state.masonryElement, {
                itemSelector: '.result-grid',
                gutter: px('0.9375rem'),
                transitionDuration: 0,
                stagger: 0
            });
        }
        else if(state.masonry) {
            state.masonry.destroy();
            state.masonry = undefined;
            // Masonry is not destroying properly and I dont know why
            // Time for the nuclear option

            Array.from(state.masonryElement.querySelectorAll('.result-grid')).forEach((result) => result.removeAttribute('style'));
        }

        return c1;
    }, 'table-view');
}
